import { useSelector } from 'react-redux';
import usePermissions from './usePermissions';
import usePlgOnboarding from './usePlgOnboarding';
import { FeatureFlags } from '../../services/exports/Constants';

/**
 * Who may open the onboarding wizard for the selected restaurant (FOO-6351):
 *  - the partner themselves (`usePlgOnboarding`: non-master, non-store role,
 *    provider has `plg_onboarding`), and
 *  - the restaurant owner the partner provisioned (two-actor flow, C10): a
 *    StoreAdmin whose provider has `plg_onboarding`. Their entry point is the
 *    "Continue setup" banner/card, so the guard must admit them or that CTA
 *    bounces them home.
 *
 * Masters and store users of non-flagged providers are never admitted, so
 * nothing changes for existing tenants. Creating a restaurant (`NewRestaurant`)
 * stays partner-only.
 */
export default function useCanAccessOnboardingWizard() {
  const isPlgPartner = usePlgOnboarding();
  const { isMerchant } = usePermissions();
  const { serviceProvider } = useSelector((state) => state.currentServiceProvider);

  const providerHasPlg = (serviceProvider?.enabled_feature_flags ?? []).includes(FeatureFlags.PlgOnboarding);

  return isPlgPartner || (isMerchant && providerHasPlg);
}
